export const FETCH_DATA_CYCLES_REQUEST = 'dataCycles/FETCH_DATA_CYCLES_REQUEST'
export const FETCH_DATA_CYCLES_SUCCESS = 'dataCycles/FETCH_DATA_CYCLES_SUCCESS'
export const FETCH_DATA_CYCLES_FAILURE = 'dataCycles/FETCH_DATA_CYCLES_FAILURE'

export const FETCH_DATA_CYCLE_REQUEST = 'street/FETCH_DATA_CYCLE_REQUEST'
export const FETCH_DATA_CYCLE_SUCCESS = 'street/FETCH_DATA_CYCLE_SUCCESS'
export const FETCH_DATA_CYCLE_FAILURE = 'street/FETCH_DATA_CYCLE_FAILURE'

export const DELETE_DATA_CYCLE_REQUEST = 'dataCycles/DELETE_DATA_CYCLE_REQUEST'
export const DELETE_DATA_CYCLE_SUCCESS = 'dataCycles/DELETE_DATA_CYCLE_SUCCESS'
export const DELETE_DATA_CYCLE_FAILURE = 'dataCycles/DELETE_DATA_CYCLE_FAILURE'

export const CREATE_DATA_CYCLE_REQUEST = 'dataCycles/CREATE_DATA_CYCLE_REQUEST'
export const CREATE_DATA_CYCLE_SUCCESS = 'dataCycles/CREATE_DATA_CYCLE_SUCCESS'
export const CREATE_DATA_CYCLE_FAILURE = 'dataCycles/CREATE_DATA_CYCLE_FAILURE'

export const UPDATE_DATA_CYCLE_REQUEST = 'dataCycles/UPDATE_DATA_CYCLE_REQUEST'
export const UPDATE_DATA_CYCLE_SUCCESS = 'dataCycles/UPDATE_DATA_CYCLE_SUCCESS'
export const UPDATE_DATA_CYCLE_FAILURE = 'dataCycles/UPDATE_DATA_CYCLE_FAILURE'

export const FETCH_BATCH_TASK_STATUS_REQUEST =
  'dataCycles/FETCH_BATCH_TASK_STATUS_REQUEST'
export const FETCH_BATCH_TASK_STATUS_SUCCESS =
  'dataCycles/FETCH_BATCH_TASK_STATUS_SUCCESS'
export const FETCH_BATCH_TASK_STATUS_FAILURE =
  'dataCycles/FETCH_BATCH_TASK_STATUS_FAILURE'

export const FETCH_DATA_CYCLE_STATS_REQUEST =
  'dataCycles/FETCH_DATA_CYCLE_STATS_REQUEST'
export const FETCH_DATA_CYCLE_STATS_SUCCESS =
  'dataCycles/FETCH_DATA_CYCLE_STATS_SUCCESS'
export const FETCH_DATA_CYCLE_STATS_FAILURE =
  'dataCycles/FETCH_RDN_STATS_FAILURE'

export const SWITCH_DATA_CYCLE_REQUEST = 'dataCycles/SWITCH_DATA_CYCLE_REQUEST'
export const SWITCH_DATA_CYCLE_SUCCESS = 'dataCycles/SWITCH_DATA_CYCLE_SUCCESS'
export const SWITCH_DATA_CYCLE_FAILURE = 'dataCycles/SWITCH_DATA_CYCLE_FAILURE'

export const STOP_DATA_CYCLE_SWITCHING_REQUEST =
  'dataCycles/STOP_DATA_CYCLE_SWITCHING_REQUEST'
export const STOP_DATA_CYCLE_SWITCHING_SUCCESS =
  'dataCycles/STOP_DATA_CYCLE_SWITCHING_SUCCESS'
export const STOP_DATA_CYCLE_SWITCHING_FAILURE =
  'dataCycles/STOP_DATA_CYCLE_SWITCHING_FAILURE'

export const FETCH_INIT_SWITCH_STATS_REQUEST =
  'street/FETCH_INIT_SWITCH_STATS_REQUEST'
export const FETCH_INIT_SWITCH_STATS_SUCCESS =
  'street/FETCH_INIT_SWITCH_STATS_SUCCESS'
export const FETCH_INIT_SWITCH_STATS_FAILURE =
  'street/FETCH_INIT_SWITCH_STATS_FAILURE'

export const UPDATE_FIELD = 'dataCycles/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'dataCycles/SET_DEFAULT_DATA'
